export default "__VITE_ASSET__LhEs0nsm__"